import * as z from 'zod/mini';

export const PromoCodeResponseSchema = z.object({
  valid: z.boolean(),
  promo_code: z.string(),
});
